/**
 * Sana/vaqtni yagona formatda ko'rsatish: DD-MM-YYYY HH:mm
 *
 * Kiruvchi qiymat quyidagilardan biri bo'lishi mumkin:
 *  - unix timestamp (sekundlarda, baza standarti) yoki millisekundlarda
 *  - Date obyekti
 *  - sana satri (ISO va h.k.)
 *
 * Noto'g'ri/bo'sh qiymatda bo'sh satr qaytaradi.
 */
export function formatDateTime(value) {
  if (value === null || value === undefined || value === "") return "";

  let d;
  if (value instanceof Date) {
    d = value;
  } else if (typeof value === "number" || /^\d+(\.\d+)?$/.test(String(value).trim())) {
    let num = Number(value);
    // 1e12 dan kichik bo'lsa — sekundlarda (baza standarti), ms ga o'tkazamiz
    if (num < 1e12) num *= 1000;
    d = new Date(num);
  } else {
    d = new Date(value);
  }

  if (isNaN(d.getTime())) return "";

  const pad = n => (n < 10 ? "0" + n : "" + n);
  const dd = pad(d.getDate());
  const mm = pad(d.getMonth() + 1);
  const yyyy = d.getFullYear();
  const hh = pad(d.getHours());
  const min = pad(d.getMinutes());

  return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
}

/**
 * Composable: komponent ichida { formatDateTime } ni olish uchun.
 */
export function useDateFormat() {
  return { formatDateTime };
}

export default formatDateTime;
